import { render, staticRenderFns } from "./PriceBanner.vue?vue&type=template&id=2d21ec2a&lang=pug"
import script from "./PriceBanner.vue?vue&type=script&lang=ts"
export * from "./PriceBanner.vue?vue&type=script&lang=ts"
import style0 from "./PriceBanner.vue?vue&type=style&index=0&id=2d21ec2a&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default})
